// extracted by mini-css-extract-plugin
export var button = "_65-0";
export var icon = "_65-1";